/*
 * Return boolean. Does values have valid contact information?
 * At least 1 email address OR 1 phone number is valid.
 * A complete home address is valid.
 */
export const validContact = values => {
  if (values) {
    const {
      email,
      work_email,
      home_phone,
      cell_phone,
      work_phone,
      address,
      city,
      state,
      zip
    } = values

    if (email || work_email || home_phone || cell_phone || work_phone) {
      return true
    }
    if (address && city && state && zip) {
      return true
    }
  }
  return false
}
